export const QUERY_LIMIT = 25

export const FILTER_KEYS = {
  ID: "id",
  FIRSTNAME: "firstname",
  LASTNAME: "lastname",
  UNIVERSE: "universeId",
  AGENT: "agentId",
  LAST_COMMENT: "dateLastComment",
  EXPERIENCES_LAST_UPDATE: "dateExperiencesLastUpdate",
  AVAILABLE: "dateAvailable",
  CREATED: "dateCreated",
  SKILLS_FILE_UPLOADED: "skillsFileUploaded",
  CV_UPLOADED: "cvUploaded",
  HAS_LINKEDIN: "hasLinkedin",
  LATE: "late",
  MEETING_BOOKED: "meetingBooked",
  SEEN: "seen",
  COMPLETE: "complete",
  CDI: "cdi",
  PUBLIC: "public",
  HAS_COMMENTS: "hasComments",
}

export const FIELD_KEYS = {
  ID: "id",
  FIRSTNAME: "user.firstname",
  LASTNAME: "user.lastname",
  UNIVERSE: "user.main_universe",
  AGENT: "agent",
  LAST_COMMENT: "date_last_comment",
  EXPERIENCES_LAST_UPDATE: "date_experiences_last_update",
  AVAILABLE: "date_available",
  CREATED: "date_created",
  SKILLS_FILE_UPLOADED: "skills_file_uploaded",
  CV_UPLOADED: "cv_uploaded",
  HAS_LINKEDIN: "user.has_linkedin",
  LATE: "late",
  MEETING_BOOKED: "user.meeting_booked",
  SEEN: "seen",
  COMPLETE: "user.complete",
  CDI: "cdi",
  PUBLIC: "public",
  HAS_COMMENTS: "has_comments",
}

export const FIELD_TYPES = {
  OBJECT: 'object',
  DATE: 'date',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  STRING: 'string',
}

export const SORTING_ASC = "ASC"
export const SORTING_DESC = "DESC"

export const DEFAULT_SORTING = {dateCreated: SORTING_DESC}

export const REQUIREMENTS_CHOICES = [
  {text: 'Défaut'}, // ℹ️ Nom / Prénom
  {value: 1, text: 'ID (Sans le #)'},
  {value: 2, text: 'Email'},
  {value: 3, text: 'Téléphone'},
]

export const FILTER_GROUPS = [
  {
    label: "Identité",
    filters: [
      {
        label: 'FL ID',
        filterKey: FILTER_KEYS.ID,
        type: FIELD_TYPES.NUMBER,
      },
      {
        label: 'Prénom',
        filterKey: FILTER_KEYS.FIRSTNAME,
        type: FIELD_TYPES.STRING,
      },
      {
        label: 'Nom',
        filterKey: FILTER_KEYS.LASTNAME,
        type: FIELD_TYPES.STRING,
      },
    ]
  },
  {
    label: "Rattaché à",
    filters: [
      {
        label: 'Univers',
        filterKey: FILTER_KEYS.UNIVERSE,
        type: FIELD_TYPES.OBJECT,
        choiceKey: 'universes',
        choiceValueKey: 'id',
        choiceLabelKey: 'name',
      },
      {
        label: 'Propriétaire',
        filterKey: FILTER_KEYS.AGENT,
        type: FIELD_TYPES.OBJECT,
        choiceKey: 'agents',
        choiceValueKey: 'id',
        choiceLabelKey: 'fullname',
      },
    ]
  },
  {
    label: "Suivi (dates)",
    filters: [
      {
        label: 'Dernier commentaire',
        filterKey: FILTER_KEYS.LAST_COMMENT,
        type: FIELD_TYPES.DATE,
      },
      {
        label: 'Dernière modification mission',
        filterKey: FILTER_KEYS.EXPERIENCES_LAST_UPDATE,
        type: FIELD_TYPES.DATE,
      },
      {
        label: 'Disponibilité',
        filterKey: FILTER_KEYS.AVAILABLE,
        type: FIELD_TYPES.DATE,
      },
    ]
  },
  {
    label: "Inscription (dates)",
    filters: [
      {
        label: 'Création du profil',
        filterKey: FILTER_KEYS.CREATED,
        type: FIELD_TYPES.DATE,
      },
    ]
  },
  {
    label: "Statuts",
    filters: [
      {
        label: 'Complet',
        filterKey: FILTER_KEYS.COMPLETE,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
      {
        label: 'CDI',
        filterKey: FILTER_KEYS.CDI,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
      {
        label: 'Retard',
        filterKey: FILTER_KEYS.LATE,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
      {
        label: 'Public',
        filterKey: FILTER_KEYS.PUBLIC,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
    ]
  },
  {
    label: "Informations du profil",
    filters: [
      {
        label: 'DC uploadé',
        filterKey: FILTER_KEYS.SKILLS_FILE_UPLOADED,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
      {
        label: 'CV uploadé',
        filterKey: FILTER_KEYS.CV_UPLOADED,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
      {
        label: 'Linkedin',
        filterKey: FILTER_KEYS.HAS_LINKEDIN,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
      {
        label: 'RDV pris',
        filterKey: FILTER_KEYS.MEETING_BOOKED,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
      {
        label: 'Vu en RDV',
        filterKey: FILTER_KEYS.SEEN,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
      {
        label: 'Commentaires',
        filterKey: FILTER_KEYS.HAS_COMMENTS,
        type: FIELD_TYPES.BOOLEAN,
        defaultValue: "0",
      },
    ]
  },
]

export const comparison = {
  GREATER: {
    value: "gt",
    symbol: '>',
  },
  GREATER_EQUAL: {
    value: "gte",
    symbol: '>=',
  },
  LESSER: {
    value: "lt",
    symbol: '>',
  },
  LESSER_EQUAL: {
    value: "lte",
    symbol: '<=',
  },
}

export const FILTER_SHORTCUTS = Object.freeze({
  FOLLOW: [
    {field: FILTER_KEYS.LATE, value: "1"},
    {field: FILTER_KEYS.COMPLETE, value: "1"}
  ],
  TO_VALIDATE: [
    {field: FILTER_KEYS.SKILLS_FILE_UPLOADED, value: "1"},
    {field: FILTER_KEYS.COMPLETE, value: "0"},
  ],
  MET_TO_RELAUNCH: [
    {field: FILTER_KEYS.SEEN, value: "1"},
    {field: FILTER_KEYS.COMPLETE, value: "0"},
    {field: FILTER_KEYS.SKILLS_FILE_UPLOADED, value: "0"},
  ],
  COMPLETE: [
    {field: FILTER_KEYS.COMPLETE, value: "1"},
  ],
  UNIVERSE: [
    {field: FILTER_KEYS.UNIVERSE},
  ],
  OWNER: [
    {field: FILTER_KEYS.AGENT},
  ],
})

export const TO_VALIDATE_SHORTCUT_KEY = 'TO_VALIDATE'
export const MET_TO_RELAUNCH_SHORTCUT_KEY = 'MET_TO_RELAUNCH'
export const FOLLOW_SHORTCUT_KEY = 'FOLLOW'
